module.exports = __webpack_public_path__ + "static/media/bhoomiputra_demo.863d5feb.png";